/**
 * Hub Registry - Barrel export
 * Assembles HUB_REGISTRY from core + extended definitions and re-exports helpers.
 */

import type { HubId } from '../../components/types'
import type { HubDefinition } from './types'
import { CORE_HUB_DEFINITIONS } from './definitions-core'
import { EXTENDED_HUB_DEFINITIONS } from './definitions-extended'

/** Complete registry of all Quotech hubs */
export const HUB_REGISTRY: Record<HubId, HubDefinition> = {
  ...CORE_HUB_DEFINITIONS,
  ...EXTENDED_HUB_DEFINITIONS,
} as Record<HubId, HubDefinition>

// Re-export types
export type { HubDefinition } from './types'
export { getHubUrl } from './types'

// Re-export all helper functions
export {
  getExternalLinks,
  getExternalLinks as getHubLinks,
  getExternalLinksByCategory,
  getHub,
  getHubLandingPage,
  getHubPrimaryPage,
  getHubsByCategory,
  getProductionHubs,
  getAllHubs,
  buildHubSSOLink,
  buildHubDirectLink,
  isValidHubPath,
  getHubBreadcrumbs,
} from './helpers'
